export const LOOKER_GEO_REPORT =
  "https://lookerstudio.google.com/embed/reporting/daaf7807-76ea-47a9-8d78-db7b51663273/page/dWDDE";

export enum Screens {
  Dashboard,
  Churches,
}
